import Vue from 'vue';
import App from './App.vue';
import store from "./store";
new Vue({
    store: store,
    el: '#app',
    render: function (h) { return h(App); }
});



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 4
// module chunks = 0